import React from "react";
import { usePromiseTracker } from "react-promise-tracker";
import CircularProgress from "@material-ui/core/CircularProgress";
import "./index.scss";

const Loader = () => {
  const { promiseInProgress } = usePromiseTracker({ delay: 1000 });
  return (
    promiseInProgress && (
      <div className="loading-indicator">
        <div className="spinner-container ">
          <CircularProgress />
        </div>
      </div>
    )
  );
};

export default Loader;
